export default __webpack_public_path__ + "static/media/grafema_severe_03.7375a988.jpg";